/**
 * Custom element for a "Load More" button.
 * Fetches and appends the next page of products when clicked or when the button becomes visible.
 */
class LoadMoreButton extends HTMLElement {
  constructor() {
    super();
    this.isLoading = false; // Add a loading flag
  }
    /**
   * Called when the element is connected to the DOM.
   * Sets up event listeners and an IntersectionObserver for the "Load More" button.
   */
  connectedCallback() {
    this.loadMoreBtn = this.querySelector('button');
    this.textSpan = this.loadMoreBtn?.querySelector('.load-more__text');
    this.spinner = this.loadMoreBtn?.querySelector('.load-more__spinner');
    if (this.loadMoreBtn) {
      this.loadMoreBtn.addEventListener("click", this.fetchNextPage.bind(this));
      // Observer for visibility detection
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.fetchNextPage();
            observer.unobserve(this.loadMoreBtn);
            observer.observe(this.loadMoreBtn);
          }
        });
      });
      observer.observe(this.loadMoreBtn);
    }
  }
  showLoader(show) {
    if (this.spinner && this.textSpan) {
      this.spinner.style.display = show ? '' : 'none';
      this.textSpan.style.display = show ?  '' : 'none';
    }
  }
   /**
   * Fetches the next page of products and appends them to the product grid.
   * Updates the "data-next-page" attribute and hides the button if no more pages are available.
   */
  fetchNextPage() {
    if (this.isLoading) return;
    this.isLoading = true;
    this.showLoader(true);

    let nextPageUrl = document
      .querySelector(".collection-product-container")
      .getAttribute("data-next-page");

    if (!nextPageUrl) {
      this.loadMoreBtn.style.display = "none";
      this.isLoading = false;
      this.showLoader(false);

      return;
    }

    fetch(nextPageUrl)
      .then((response) => response.text())
      .then((html) => {
        const updatedHTML = new DOMParser().parseFromString(html, "text/html");
        const newProducts = updatedHTML.querySelector(".collection-product-container");
        const allResultLoaded = updatedHTML.querySelector('.all_result_loaded');
        // if sale search, remove any search-grid-item entries and defer them
        // retrieve current search term from section container
        const term = document.querySelector('.search-content')?.getAttribute('data-search-term') || '';
        if (term.toLowerCase().includes('sale')) {
          if (!window._saleDeferred) window._saleDeferred = [];
          newProducts.querySelectorAll('.search-grid-item').forEach(el => {
            window._saleDeferred.push(el.outerHTML);
            el.remove();
          });
        }
        // const newUrl = window.location.origin + nextPageUrl;
        // window.history.pushState({ path: newUrl }, "", newUrl);
                // Use a new variable to avoid overwriting nextPageUrl mid-way
        const updatedNextPage = newProducts.getAttribute("data-next-page");
        const prevPageUrl = newProducts.getAttribute("data-prev-page");
        const productGrid = document.querySelector(".collection-product-container");
        // Preserve scroll position before appending new products
        const firstNewItem = newProducts.firstElementChild;
        const offsetTopBefore = firstNewItem.getBoundingClientRect().top;
        productGrid.insertAdjacentHTML("beforeend", newProducts.innerHTML);
        if(allResultLoaded)
        {
          const existingAllResultLoaded = document.querySelector('.all_result_loaded');
          if(existingAllResultLoaded)
          existingAllResultLoaded.remove();
          productGrid.insertAdjacentHTML("afterend", allResultLoaded.outerHTML);
        }
        theme.reinitProductGridItem();
      // Preserve scroll position after appending new products
        const offsetTopAfter = firstNewItem.getBoundingClientRect().top;
        window.scrollBy(0, offsetTopAfter - offsetTopBefore);
        if (updatedNextPage) {
          productGrid.setAttribute("data-next-page", updatedNextPage);
          productGrid.setAttribute("data-prev-page", prevPageUrl);
        } else {
          // last page reached - append deferred items and sale pagination if present
          productGrid.removeAttribute("data-next-page");
          this.loadMoreBtn.style.display = "none";  // Hide the button if no more pages

          if (window._saleDeferred && window._saleDeferred.length) {
            window._saleDeferred.forEach(html => {
              productGrid.insertAdjacentHTML('beforeend', html);
            });
            // show the appended items
            productGrid.querySelectorAll('.search-grid-item[style*="display: none"]').forEach(el => el.style.display = '');
            window._saleDeferred = [];
          }

          const pagination = document.createElement('DIV');
          pagination.id = 'sale-pagination-js';
          pagination.innerHTML = document.querySelector('#sale-pagination-js') ? document.querySelector('#sale-pagination-js').innerHTML : '';
          if (pagination.innerHTML.trim() !== '') {
            productGrid.append(pagination);
            pagination.style.display = null;
          }
        }
      })
      .catch((error) => {
        console.error("Error fetching the next page:", error);
      })
      .finally(() => {
        this.isLoading = false; // Reset loading flag after the fetch completes
        this.showLoader(false);
      });
  }
}

/**
 * Custom element for a "Load Previous" button.
 * Fetches and prepends the previous page of products when clicked or when the button becomes visible.
 */
class LoadPrevButton extends HTMLElement {
  constructor() {
    super();
     this.isLoading = false; // Initialize loading flag
  }

    /**
   * Called when the element is connected to the DOM.
   * Sets up event listeners and an IntersectionObserver for the "Load Previous" button.
   */
  connectedCallback() {
    this.loadPrevBtn = this.querySelector('button');
    this.textSpan = this.loadPrevBtn?.querySelector('.load-more__text');
    this.spinner = this.loadPrevBtn?.querySelector('.load-more__spinner');
    if (this.loadPrevBtn) {
      this.loadPrevBtn.addEventListener("click", this.fetchPrevPage.bind(this));
            // Observer for visibility detection
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {   
          // Trigger fetch when button is visible
          if (entry.isIntersecting ) {
        setTimeout(() => {
        this.fetchPrevPage(); // Wait for 6 seconds before fetching
          }, 10000);
            observer.unobserve(this.loadPrevBtn);
            observer.observe(this.loadPrevBtn);
          }
        });
      });
      observer.observe(this.loadPrevBtn);
    }
  }
  showLoader(show) {
    if (this.spinner && this.textSpan) {
      this.spinner.style.display = show ? '' : 'none';
      this.textSpan.style.display = show ? '' : 'none';
    }
  }
    /**
   * Fetches the previous page of products and prepends them to the product grid.
   * Updates the "data-prev-page" attribute and hides the button if no more pages are available.
   */
  fetchPrevPage() {
    if (this.isLoading) {
      return; // Prevent duplicate fetches
    }
    this.isLoading = true; // Set loading flag to true during the fetch
    this.showLoader(true);

    let prevPageUrl = document
      .querySelector(".collection-product-container")
      .getAttribute("data-prev-page");

    if (!prevPageUrl) {
   this.loadPrevBtn.style.display = "none"; // Hide prev button if no previous page
      this.isLoading = false; // Reset loading flag
      this.showLoader(false);
      return;
    }

    fetch(prevPageUrl)
      .then((response) => response.text())
      .then((html) => {
        const updatedHTML = new DOMParser().parseFromString(html, "text/html");
        const newProducts = updatedHTML.querySelector(".collection-product-container");
        const updatedPrevPage = newProducts.getAttribute("data-prev-page");
        const productGrid = document.querySelector(".collection-product-container");
             // Preserve scroll position before prepending new products
        const firstNewItem = newProducts.firstElementChild;
        const offsetTopBefore = firstNewItem.getBoundingClientRect().top;

        // Insert new content at the top
        // const images =  newProducts.querySelectorAll('.image-element');
        // images.forEach((image) => {
        // image.style.opacity = '1';
        // });
        productGrid.insertAdjacentHTML("afterbegin", newProducts.innerHTML);
        // theme.initQuickShop();           
            
            
       theme.reinitProductGridItem();

        // Preserve scroll position after prepending new products
        const offsetTopAfter = firstNewItem.getBoundingClientRect().top;
        window.scrollBy(0, offsetTopAfter - offsetTopBefore);

      if (updatedPrevPage) {
          productGrid.setAttribute("data-prev-page", updatedPrevPage);
          this.loadPrevBtn.style.display = "flex"; // Show prev button if there are more pages
        } else {
          productGrid.removeAttribute("data-prev-page");
          this.loadPrevBtn.style.display = "none"; // Hide prev button if no more previous pages
        }

      })
      .catch((error) => {
        console.error("Error fetching the previous page:", error);
      })
      .finally(() => {
         this.isLoading = false; // Reset loading flag after the fetch is complete
        this.showLoader(false);
      });
  }
}

// Define custom elements
customElements.define('load-more', LoadMoreButton);
customElements.define('load-prev', LoadPrevButton);